import { useFeatureFlagEnabled } from 'posthog-js/react'

/**
 * PostHog flag gating the network "Marque blanche" settings screen (the network's addresses
 * — dedicated space activation, subdomain, customer domain — and, later, visual identity).
 *
 * The feature ships dark: the flag targets the founder's account only, so the screen can be
 * exercised on real data without opening it to customers. While the flag is off (or PostHog
 * is absent — local dev, CI, ad blockers) the nav entry shows as a disabled "Bientôt" teaser
 * and the page itself renders nothing.
 */
export const WHITE_LABEL_FEATURE_FLAG = 'white-label'

/**
 * Whether the white-label settings screen may be shown. Defaults to FALSE —
 * `useFeatureFlagEnabled` returns `undefined` while flags load, and an unreleased screen
 * must never flash because analytics was slow.
 */
export function useWhiteLabelFeature(): boolean {
  return useFeatureFlagEnabled(WHITE_LABEL_FEATURE_FLAG) === true
}
